export const loader = {
  my: 4,
};
